import { Component } from '@angular/core';
import { User } from '@tytapp/models';
import { UserService } from '../user.service';
import { ActivatedRoute } from '@angular/router';
import { PageComponent, PageService, Redirection, Transfer } from '@tytapp/common';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-login-bounce',
  templateUrl: './login-bounce.component.html',
  styleUrls: ['./login-bounce.component.scss']
})
export class LoginBounceComponent extends PageComponent {

  constructor(
    pageService : PageService,
    private userService : UserService,
    private route : ActivatedRoute,
    private angulartics2GoogleTagManager : Angulartics2GoogleTagManager,
    private redirection : Redirection
  ) { 
    super(pageService);
  }
  
  @Transfer()
  user : User;
  
  get userDisplayName() {
    if (!this.user)
      return null;
    
    if (!this.user.profile)
      return null;
    
    if (this.user.profile.display_name)
      return this.user.profile.display_name;
    
    if (this.user.profile.first_name)
      return this.user.profile.first_name;
    
    if (this.user.display_name)
      return this.user.display_name;

    return null;
  }

  get userGreeting() {
    let displayName = this.userDisplayName;

    if (displayName) 
      return `Hi ${displayName}!`;
    else 
      return `Hi!`;
  }

  async init() {
    // Because we are going to send beacons that can only be sent from 
    // the client side, we need to process the login bounce page itself 
    // on the client side. Additionally, login bounce waits 2 seconds which 
    // causes a very long request (from the SSR perspective) that should not 
    // be hit. 
    // TODO: The ability to deliver the beacons in SSR would allow us to 
    // handle this and have a better user experience

    if (typeof window === 'undefined')
      return;
    
    await this.userService.ready;

    let queryParams = await this.route.queryParamMap.pipe(take(1)).toPromise();

    this.subscribe(this.userService.userChanged, async (user) => {
        this.user = user;

        let bounceURL = this.userService.bounceURL;
        this.userService.bounceURL = null;

        // Record signup analytics, if necessary

        if (queryParams.get('onboarded') === '1') {
          await this.userService.sendSocialSignupAnalytics(
            <any>queryParams.get('method') || 'login'
          );
        }

        // Never bounce back to the signup page
        if (bounceURL === '/signup')
          bounceURL = null;

        setTimeout(() => {
          this.redirection.go(bounceURL ? bounceURL : '/');
        }, 500);
    });
  }

  private appWebEvent(event : string, props : Record<string,any>) {
    this.angulartics2GoogleTagManager.eventTrack(
      event, 
      Object.assign({}, props, { event })
    );
  }
}
